// How long turbo-confirm should wait, after a confirmation resolves, before rewriting the shared
// dialog back to its original markup.
//
// The delay exists to let the dialog's exit animation finish -- rewriting its contents mid-animation
// would be visible. But the rewrite is scheduled with setTimeout and targets whatever element
// matches the dialog selector when it fires, so it outlives the confirmation that scheduled it: a
// second confirmation opened inside the window is overwritten, losing the accept button that was
// just bound to it.
//
// When the visitor has asked for reduced motion there is no exit animation to wait for, so the
// delay buys nothing and the collision window closes.
export const CONFIRM_EXIT_ANIMATION_MS = 300

export function confirmAnimationDuration() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ?
    0 :
    CONFIRM_EXIT_ANIMATION_MS
}
